import { render, staticRenderFns } from "./form-modal.vue?vue&type=template&id=729956c4&scoped=true&"
import script from "./form-modal.vue?vue&type=script&lang=js&"
export * from "./form-modal.vue?vue&type=script&lang=js&"
import style0 from "./form-modal.vue?vue&type=style&index=0&id=729956c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729956c4",
  null
  
)

export default component.exports